var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3c1117e9005a29c6236edbd55064bedd.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99b8d7c0895e5ac612d5f3300498da33.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf4b91a43164549b27d40e9538748c32.js').default;
var scope_3 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dffeab995932299a39b81f7c2154fb79.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    